import { ConsigneeValue } from "pages/shipper/RequestFormV2/defaults/consigneeDefaults";
import type { SharedAddressFieldPaths, SharedContactFieldPaths } from "./sharedAddressFieldPaths";

export const CONSIGNEE_PREFIX = "schedule.consignee" as const;

export type ConsigneeField = keyof ConsigneeValue;

export function getConsigneeFieldPath(field: ConsigneeField): `${typeof CONSIGNEE_PREFIX}.${ConsigneeField}` {
  return `${CONSIGNEE_PREFIX}.${field}`;
}

export const consigneeFieldPaths = {
  address_type: getConsigneeFieldPath("address_type"),
  same_as_delivery_address_contact: getConsigneeFieldPath("same_as_delivery_address_contact"),
  form_address_contact_type: getConsigneeFieldPath("form_address_contact_type"),
  address_reference_number: getConsigneeFieldPath("address_reference_number"),
  address_id: getConsigneeFieldPath("address_id"),
  address_name: getConsigneeFieldPath("address_name"),
  address_street: getConsigneeFieldPath("address_street"),
  address_street_line2: getConsigneeFieldPath("address_street_line2"),
  address_city: getConsigneeFieldPath("address_city"),
  address_state: getConsigneeFieldPath("address_state"),
  address_country: getConsigneeFieldPath("address_country"),
  address_zipcode: getConsigneeFieldPath("address_zipcode"),
  airport: getConsigneeFieldPath("airport"),
  airport_name: getConsigneeFieldPath("airport_name"),
  seaport: getConsigneeFieldPath("seaport"),
  seaport_name: getConsigneeFieldPath("seaport_name"),
  contact_name: getConsigneeFieldPath("contact_name"),
  contact_phone: getConsigneeFieldPath("contact_phone"),
  contact_email: getConsigneeFieldPath("contact_email"),
} as const;

export function getConsigneeSharedAddressFieldPaths(): SharedAddressFieldPaths {
  return {
    address_type: consigneeFieldPaths.address_type,
    address_id: consigneeFieldPaths.address_id,
    address_name: consigneeFieldPaths.address_name,
    address_reference_number: consigneeFieldPaths.address_reference_number,
    address_street: consigneeFieldPaths.address_street,
    address_street_line2: consigneeFieldPaths.address_street_line2,
    address_city: consigneeFieldPaths.address_city,
    address_state: consigneeFieldPaths.address_state,
    address_country: consigneeFieldPaths.address_country,
    address_zipcode: consigneeFieldPaths.address_zipcode,
    airport_name: consigneeFieldPaths.airport_name,
    airport_code: consigneeFieldPaths.airport,
    seaport_name: consigneeFieldPaths.seaport_name,
    seaport_code: consigneeFieldPaths.seaport,
  };
}

export function getConsigneeSharedContactFieldPaths(): SharedContactFieldPaths {
  return {
    contact_name: consigneeFieldPaths.contact_name,
    contact_phone: consigneeFieldPaths.contact_phone,
    contact_email: consigneeFieldPaths.contact_email,
  };
}
